module.exports = __webpack_public_path__ + "static/media/img_molecule.65504c9f.jpg";